import { render, staticRenderFns } from "./LandingFooter.vue?vue&type=template&id=3555f914&"
import script from "./LandingFooter.vue?vue&type=script&lang=js&"
export * from "./LandingFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports